const MEMBERSHIP_LOGIN_PATH = '/_hcms/mem/login?redirect_url=';
export const getMembershipLoginUrl = redirectUrl => {
  return `${MEMBERSHIP_LOGIN_PATH}${encodeURIComponent(redirectUrl)}`;
};